import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {commonFormikPropTypes} from 'propTypes/formik';

const ProductionQualityControlOptions = (
    {
        values, errors, touched, handleChange, handleBlur,
        name, options, title, disabled,
    },
) =>
    (
        <div className="mb-3">
            <h5>{title}</h5>
            {options.map(option =>
                (
                    <div key={option.value} className="custom-control custom-radio">
                        <input
                            type="radio"
                            className={classNames(
                                'custom-control-input',
                                {'is-invalid': touched[name] && errors[name]},
                            )}
                            name={name}
                            id={option.value}
                            value={option.value}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            checked={values[name] === option.value}
                            required
                            disabled={disabled}
                        />
                        <label
                            htmlFor={option.value}
                            className="custom-control-label"
                        >
                            <span>{option.label}</span><span className="text-muted ml-2">{option.percentage} %</span>
                        </label>
                    </div>
                ),
            )}
            {touched[name] && errors[name] && <div className="text-danger">{errors[name]}</div>}
        </div>
    );


ProductionQualityControlOptions.propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        percentage: PropTypes.number.isRequired,
    })).isRequired,
    ...commonFormikPropTypes,
};


export default ProductionQualityControlOptions;



// WEBPACK FOOTER //
// ./src/components/ProductionQualityControlOptions/ProductionQualityControlOptions.js